import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "pandly_welcome_modal_dismissed"

export default class extends Controller {
  connect() {
    const params = new URLSearchParams(window.location.search)
    if (params.get("welcome") === "1" && !localStorage.getItem(STORAGE_KEY)) {
      this.show()
    }
  }

  show() {
    this.element.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  dismiss() {
    localStorage.setItem(STORAGE_KEY, "1")
    this.element.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    const url = new URL(window.location)
    url.searchParams.delete("welcome")
    history.replaceState({}, "", url)
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.dismiss()
  }
}
